<template>

<dataroom-modal
    :modal_mode="modal_mode"
    :modal_data="modal_data"
    :roles="rolesdata"
    :permissions="permissionsdata"
    :readonly
        @close="closeModalDataroom()"
        @new-document="needReloadFolder"
        @edit-document="needReloadFolder"
        @edit-template="needReloadFolder"
        @add-role="addRoleToPermission($event);closeModalDataroom()"
            v-if="modal_mode" />


<div class="octolo-dataroom-container">
    <div class="odr-header" v-if="toolbar">
        <div class="odr-header-actions">
            <!--<span class="material-icons">&#xe5c4;</span>
            <span class="material-icons">&#xe5c8;</span>-->
            <span class="material-icons"
                @click="folderRootInit(folderdata.response?.parent || 'root')"
                    v-if="folder_init_uid != current_uid">&#xe5d8;</span>
            <span class="material-icons" @click="folderRootInit(current_uid)" :class="{spin: dytIsBusy(current_uid)}">&#xe5d5;</span>
        </div>
        <div class="odr-header-title" v-if="folder_path.length">
            <template v-for="(folder, index) in folder_path" :key="index">
                <span class="odr-header-folder" @click="folderRootInit(folder.uid)">{{ folder.name }}</span>
                <span class="material-symbols-outlined split" v-if="index < folder_path.length - 1">&#xe409;</span>
            </template>
        </div>
        <div class="odr-header-title" v-else>/</div>
        <div class="odr-header-actions">
            <span class="material-symbols-outlined"
                :class="{enable: viewinit=='permission'}"
                    @click="viewinit='permission'"
                        v-if="permissions_enabled">&#xf775;</span>
            <span class="material-icons" :class="{enable: viewinit=='system'}" @click="viewinit='system'">&#xe896;</span>
            <span class="material-icons" :class="{enable: viewinit=='stack'}" @click="viewinit='stack'">&#xe94b;</span>
        </div>
    </div>

    <component
        :init_uid="folder_init_uid"
        :header
        :header_exclude
        :add_folder_msg
        :add_document_msg
        :readonly
        :toolbar
        :rootname
        :fileapi
        :documentapi
        :busy="is_busy"
        :is="viewinit"
        :key="viewinit+current_uid"
        :root="folderdata.response"
        :parent="folderdata.response.parent"
        :folders="folderdata.folders"
        :update_folders="folderdata.update"
        :documents="folderdata.documents"
        :reload_folder="last_reload_folder"
        :ask_documents="ask_documents"
        :permissions="permissionsdata"
            @config="$emit('config', $event)"
            @edit-document-reset=startResetDocument($event)
            @edit-document-template="startEditDocumentTemplate($event)"
            @edit-document="startEditDocument($event)"
            @view-document="startViewDocument($event)"
            @ask-create-document="startNewDocument($event)"
            @folder-choice="folderRootInit($event)"
            @folder-change="folderRootInit($event)"
            @remove-role="removeRoleToPermission($event)"
            @modal-permission="openModalDataroom('permissions')"
            @add-permission="updatePermission($event, 'add')"
            @remove-permission="updatePermission($event, 'remove')"
                v-if="current_uid" />

</div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import dataroom from "@/libraries/dataroom/dataroom.js";

export default {
    mixins: [dataroom],
    data: () => ({
        viewinit: 'system',
        modal_mode: null,
        modal_data: null,
    }),
    components: {
        DataroomModal: defineAsyncComponent(() => import('@/libraries/dataroom/modal.vue')),
        permission: defineAsyncComponent(() => import('@/libraries/dataroom/permission/index.vue')),
        grid: defineAsyncComponent(() => import('@/libraries/dataroom/grid/index.vue')),
        stack: defineAsyncComponent(() => import('@/libraries/dataroom/stack/index.vue')),
        system: defineAsyncComponent(() => import('@/libraries/dataroom/system/index.vue')),
        depositUpload: defineAsyncComponent(() => import('@/libraries/dataroom/deposit/upload.vue')),
        depositConfig: defineAsyncComponent(() => import('@/libraries/dataroom/deposit/config.vue')),
    },
    props: {
        view: { type: String, default: 'stack', },
    },
    watch: {
        view(newVal){
            this.initRoles();
        },
    },
    async created(){
        this.viewinit = this.view;
        if(this.view == 'depositUpload')
            this.folder_init_uid = this.uid;
        else
            await this.folderRootInit(this.uid);
        this.initRoles();
    },
    computed: {
        thereIsSomething(){
            return this.folderdata?.folders?.length || this.folderdata?.documents?.length || this.ask_documents?.length;
        },
    },
    methods: {
        initRoles(){
            if(this.viewinit == 'permission'){
                this.loadRoles().then(response => {
                    this.rolesdata = response.data;
                    this.permissionsdata.push(this.rolesdata[0]);
                });
            }
        },
        openModalDataroom(mode, data){
            this.modal_mode = mode;
            this.modal_data = data;
        },
        closeModalDataroom(){
            this.modal_mode = null;
            this.modal_data = null;
        },
        needReloadFolder($event){
            if(this.current_uid == $event){
                this.folderRootInit(this.uid);
            }else{
                this.last_reload_folder = { folder: $event.detail?.folder, date: new Date(),}
            }
        },
    }

}
</script>
